import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import mixins from "./mixins/index";
import ElementUI from "element-ui";
import "default-passive-events";
import globalMessageBox from "./components/globalMessageBox";
import "element-ui/lib/theme-chalk/index.css";
import env from "./utils/env";
Vue.prototype.$env = env;
// 引入全局组件

// 查询重置按钮
import cxandcz from "@/components/cxandcz.vue";
// 多个功能性按钮
import morebtn from "@/components/multipleButtons.vue";
// 封装分页器组件
import pagination from "@/components/pagination.vue";

//封装日期选择器
import datePicker from "@/components/datepicker.vue";

//封装下拉选择框
import select from "@/components/select.vue";

// 选择代理人弹出框
import selectAgent from "@/components/seleagentdailog.vue";

// 选择行业弹出框
import treeDialog from "@/components/Treedialog.vue";

// 表格编辑删除组件
import Tableeditdel from "./components/tableeditdel.vue";

// 下拉列表
import alltypeSelect from '@/components/alltypeselect.vue'

// 使用全局组件
Vue.component("ccBtn", cxandcz);
Vue.component("moreBtn", morebtn);
Vue.component("paginaTion", pagination);
Vue.component("datePicker", datePicker);
Vue.component("seLect", select);
Vue.component("selectAgent", selectAgent);
Vue.component("treeDialog", treeDialog);
Vue.component("tableDeledit", Tableeditdel);
Vue.component('alltypeSelect', alltypeSelect)

// 全局组件挂载
Vue.config.productionTip = false;
Vue.mixin(mixins);
Vue.use(ElementUI);
Vue.use(globalMessageBox);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
